import React from 'react';
import {useTable} from 'react-table';
import {FormattedMessage} from 'react-intl';
import {CommonTable} from '../../_common/components/CommonTable/CommonTable';
import {useTransfersByAgentContext} from '../contexts/TransfersByAgentContext';
import styles from './styles.module.scss';

export function TableSplitLines() {
  const {columns, dataSplitReceiptLines} = useTransfersByAgentContext();

  return (
    <div>
      <h3>
        <FormattedMessage
          id="transfersByAgent-split-lines"
          defaultMessage={`Split lines (${dataSplitReceiptLines.length})`}
          values={{count: dataSplitReceiptLines.length}}
        />
      </h3>
      <CommonTable
        tableProps={useTable({columns, data: dataSplitReceiptLines})}
        customContainerStyles={'w-100'}
        customHeaderStyles={styles.tableHeader}
        customContainerID={'bulkActionsTableContainer'}
        customTableStyles={'transfers-split-lines'}
        customTableHeadColor={'transfers-tableHead'}
      />
    </div>
  )
}

export default TableSplitLines;
